import securitySetting from "../views/personalSetting/components/securitySetting.vue"

import personalSetting from "../views/personalSetting/index.vue"
import modulesNav from "../views/modulesNav/index.vue"
import resetPwd from "../../lib/components/resetPwd.vue"
import sysAuth from "../../lib/components/sysAuth.vue"
import genAuth from "../../lib/components/genAuth.vue"


import genDeclareFile from "../../lib/components/genDeclareFile.vue"

//移动端相关
import phoneModulesNav from "../views/phoneModulesNav/index.vue"
import PadUserInfo from "../../lib/components/padComponents/PadUserInfo.vue"
import PadUserSettings from "../../lib/components/padComponents/PadUserSettings.vue"
import PadUserDetails from "../../lib/components/padComponents/PadUserDetails.vue"
import PadUserFace from "../../lib/components/padComponents/PadUserFace.vue"
import PadUithemais from "../../lib/components/padComponents/PadUithemais.vue"


//框架路由
export default [
  {
    name: "core-accountSetting",
    isPublic: true,
    meta: { title: "修改密码" },
    component: securitySetting,
  },
  {
    name: "core-personalSetting",
    path: "core-personalSetting/:key",
    MenuParams: { key: "null" },
    isPublic: true,
    meta: { title: "个人设置" },
    component: personalSetting,
  },
  {
    name: "core-modulesNav",
    isPublic: true,
    path: "core-modulesNav:index",
    MenuParams: { index: 0 },
    meta: { title: "菜单" },
    component: modulesNav, //极简布局显示菜单的子集
  },
  {
    name: "core-resetPwd",
    path: "/core-resetPwd",
    isPublic: true,
    meta: { title: "修改密码" },
    component: resetPwd,
  },
  {
    name: "core-auth",
    path: "/core-auth",
    isPublic: true,
    meta: { title: "系统授权" },
    component: sysAuth,
  },
  {
    name: "core-gen-auth",
    isPublic: true,
    meta: { title: "生成授权" },
    component: genAuth,
  },
  {
    name: "core-gen-declareFile",
    isPublic: true,
    meta: { title: "生产声明" },
    component: genDeclareFile,
  },

  //于移动端有关专门路由
  {
    name: "core-phoneModulesNav",
    isPublic: true,
    path: "core-phoneModulesNav:index",
    MenuParams: { index: 0 },
    meta: { title: "菜单" },
    component: phoneModulesNav, //手机布局显示菜单的子集
  },
  {
    name: "app-pad-userinfo",
    isPublic: true,
    component: PadUserInfo,//个人信息
  },
  {
    name: "app-pad-userSettings",
    path: "app-pad-userSettings/:key",
    isPublic: true,
    MenuParams: { key: "null" },
    meta: { title: "个人设定" },
    component: PadUserSettings,
  },
  {
    name: "app-pad-uithemais",
    isPublic: true,
    meta: { title: "主题设置" },
    component: PadUithemais,
  },
  {
    name: "app-pad-user-details",
    isPublic: true,
    meta: { title: "账户设置" },
    component: PadUserDetails,
  },
  {
    name: "app-pad-user-face",
    isPublic: true,
    meta: { title: "个人头像" },
    component: PadUserFace,
  }
];

//
